(function () {
  if (window.__mvCart) return;
  window.__mvCart = true;

  function pad(n) { return String(n).padStart(2, '0'); }

  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n--;
    }
    return d;
  }

  function tick() {
    document.querySelectorAll('[data-mv-end]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-mv-end'));
      var out = el.querySelector('[data-mv-countdown]');
      var diff = end - Date.now();
      if (isNaN(end) || diff <= 0) { el.hidden = true; return; }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      if (out) {
        out.textContent = (el.getAttribute('data-mv-label') || '') + ' ' + (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(sec) + 's';
      }
    });

    document.querySelectorAll('[data-mv-eta]:not([data-mv-done])').forEach(function (el) {
      var lang = el.getAttribute('data-mv-lang') === 'en' ? 'en-GB' : 'es-ES';
      var a = addBusinessDays(new Date(), parseInt(el.getAttribute('data-min'), 10));
      var b = addBusinessDays(new Date(), parseInt(el.getAttribute('data-max'), 10));
      var f = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' });
      el.textContent = lang === 'en-GB' ? f.format(a) + ' – ' + f.format(b) : 'del ' + f.format(a) + ' al ' + f.format(b);
      el.setAttribute('data-mv-done', '1');
    });
  }

  tick();
  setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);

  // Evita que el selector de talla del upsell dispare la lógica de cantidades del carrito
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-mv-variant]')) {
      e.stopPropagation();
      e.target.classList.remove('mv-error');
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mv-add]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.mv-upsell__card');
    var field = card && card.querySelector('[data-mv-variant]');
    var id = field && field.value;
    if (!id) {
      if (field) { field.classList.add('mv-error'); field.focus(); }
      return;
    }
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-mv-adding') || '…';

    var drawer = document.querySelector('cart-drawer');
    var inDrawer = !!btn.closest('cart-drawer');
    var body = { items: [{ id: parseInt(id, 10), quantity: 1 }] };
    if (inDrawer && drawer) body.sections = 'cart-drawer,cart-icon-bubble';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || !res.items) throw new Error((res && res.description) || 'error');
        if (inDrawer && drawer && res.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: id, sections: res.sections });
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.textContent = btn.getAttribute('data-mv-error') || 'Error';
        setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 2000);
      });
  });
})();
